// theme/createPalette.ts
import { PaletteOptions } from "@mui/material"
import { PaletteExtending } from "../theme/declarations"

export type ICustomizedPalette = PaletteOptions & PaletteExtending

export const lightPalette = (primaryColor: string): ICustomizedPalette => ({
  primary: {
    main: primaryColor,
    light: "#28C76F",
    dark: primaryColor,
  },

  secondary: {
    main: "#B53DFF",
  },

  warning: {
    main: "#FCBF63",
  },

  error: {
    main: "#EA5455",
  },

  label: {
    main: "#000",
  },

  paper: {
    main: "#F5F5F5",
  },

  extends: {},

  common: {
    black: "#2B303A",
    white: "#FFFFFF",
  },

  text: {
    primary: "#5E5873",
    secondary: "#6E6B7B",
  },

  grey: {
    200: "#D6D6D6",
  },

  info: {
    main: "#00CFE8",
  },
})

